// src/components/About/About.js
// import React from 'react';
// import './About.css';

// const About = () => {
//   return (
//     <section id="about" className="about">
//       <div className="container">
//         <h2 className="section-title">About Me</h2>
//         <div className="about-content">
//           <div className="about-text">
//             <h3>Frontend Developer (Web & Mobile)</h3>
//            <p>
//               I’m a passionate Software Developer with over <strong>3+ years of experience</strong> building
//               scalable, user-friendly applications for both <strong>web and mobile platforms</strong>.
//               I specialize in creating clean, high-performance interfaces using modern frontend technologies.
//             </p>
//              <p>
//               My expertise includes developing responsive web applications with <strong>React</strong> and
//               cross-platform mobile applications with <strong>React Native</strong> for Android and iOS.
//               I focus on reusable components, optimized performance, and seamless user experiences.
//             </p>
//              <p>
//               I have hands-on experience integrating REST APIs, managing application state, and delivering
//               production-ready applications. I continuously stay updated with the latest frontend trends
//               and best practices to build reliable and maintainable solutions.
//             </p>

//             <p>With a strong focus on clean code and user-centered design, I've developed several applications that are currently live on the Play Store and App Store, serving thousands of users worldwide.</p>
//             <p>I stay updated with the latest trends in mobile development and continuously strive to enhance my skills to deliver cutting-edge solutions.</p>
//             <div className="about-actions">
//               <a href="#contact" className="btn btn-primary">Get In Touch</a>
//               <a href="/files/Habiba_Shahidi_Software_Developer_ReactJS_ReactNative.pdf" download className="btn btn-secondary">
//                 Download CV
//               </a>
//             </div>
//           </div>
//           <div className="about-image">
//             <div className="image-container">
//               <img 
//                 src="/images/AboutImg.png" 
//                 alt="Habiba Shahidi - Frontend Developer" 
//                 className="profile-photo"
//               />
//               <div className="image-overlay">
//                 <div className="overlay-content">
//                   <span className="overlay-text">Habiba Shahidi</span>
//                   <span className="overlay-role">Software Developer</span>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default About;

// src/components/About/About.js
import React from 'react';
import { Award, Code2, Users, Target } from 'lucide-react';
import './About.css';

const About = () => {
  return (
    <section id="about" className="about-section">
      <div className="container">
        <div className="section-header">
          <span className="section-subtitle">About Me</span>
          <h2 className="section-title">Crafting Digital Experiences That Matter</h2>
          <p className="section-description">
            I transform complex problems into elegant, user-centric solutions through modern mobile & web technologies
          </p>
        </div>

        <div className="about-content">
          <div className="about-image-container">
            <div className="profile-image-wrapper">
              {/* Replace with your actual image */}
              <img 
                src="/images/AboutImg.png" 
                alt="Habiba Shahidi - Senior Frontend Developer"
                className="profile-image"
              />
              
              <div className="experience-badge">
                <div className="badge-content">
                  <Award size={20} />
                  <div className="badge-text">
                    <span className="years">6+</span>
                    <span>Years Experience</span>
                  </div>
                </div>
              </div>
              
              <div className="tech-tags">
                <span className="tech-tag">React</span>
                <span className="tech-tag">React Native</span>
                <span className="tech-tag">TypeScript</span>
              </div>
            </div>
          </div>

          <div className="about-details">
            <div className="about-intro">
              <h3>Frontend & Mobile Application Developer</h3>
              <p className="intro-text">
                I'm a passionate software engineer specializing in building scalable, high-performance 
                applications for both web and mobile platforms. With over 6 years of professional experience, 
                I've successfully delivered production-grade solutions that serve thousands of users worldwide.
              </p>
            </div>

            <div className="expertise-areas">
              <div className="expertise-item">
                <div className="expertise-icon">
                  <Code2 size={24} />
                </div>
                <div>
                  <h4>Frontend Development</h4>
                  <p>Building responsive web applications with React, Next.js, and modern JavaScript frameworks</p>
                </div>
              </div>
              
              <div className="expertise-item">
                <div className="expertise-icon">
                  <Users size={24} />
                </div>
                <div>
                  <h4>Mobile Application Development</h4>
                  <p>Developing cross-platform mobile apps with React Native for iOS and Android</p>
                </div>
              </div>
              
              <div className="expertise-item">
                <div className="expertise-icon">
                  <Target size={24} />
                </div>
                <div>
                  <h4>UI/UX Excellence</h4>
                  <p>Crafting intuitive user interfaces with attention to performance and accessibility</p>
                </div>
              </div>
            </div>

            <div className="professional-highlights">
              <h4>Professional Approach</h4>
              <ul className="highlight-list">
                <li>
                  <span className="highlight-icon">✓</span>
                  <span>Strong focus on clean, maintainable code and scalable architecture</span>
                </li>
                <li>
                  <span className="highlight-icon">✓</span>
                  <span>Proficient in state management, API integration, and performance optimization</span>
                </li>
                <li>
                  <span className="highlight-icon">✓</span>
                  <span>Experience with CI/CD pipelines, testing frameworks, and agile methodologies</span>
                </li>
                <li>
                  <span className="highlight-icon">✓</span>
                  <span>Committed to staying current with emerging technologies and best practices</span>
                </li>
              </ul>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default About;